/* eslint-disable react/prop-types */
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { Form, Placeholder } from 'react-bootstrap';
import { useTable, useSortBy, usePagination, useRowSelect, useGlobalFilter, useGroupBy, useExpanded } from 'react-table';
/* import CardDropdown from '../CardDropdown'; */

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
 const defaultRef = useRef();

 const resolvedRef = ref || defaultRef;

 useEffect(() => {
  resolvedRef.current.indeterminate = indeterminate;
 }, [resolvedRef, indeterminate]);

 return <Form.Check.Input className="ms-1" type="checkbox" ref={resolvedRef} {...rest} />;
});

// Crear un renderizador de celdas editable
const EditableCell = ({
 value: initialValue,
 row: { index, values },
 column: { id },
 //updateMyData, // Esta es una función personalizada que proporcionamos a nuestra instancia de tabla
 editableRowIndex: { currentIndex, data } // índice de la fila que solicitamos para editar
}) => {
 // Necesitamos mantener y actualizar el estado de la celda normalmente
 const [value, setValue] = useState(initialValue === undefined ? null : initialValue);

 /* console.log(
    { initialValue, index, values, id, currentIndex, data, value },
    'se esta actualizando'
  ); */

 /* const onChange = e => {
    setValue(e.target.value);
  };

  // Solo actualizaremos los datos externos cuando la entrada esté borrosa
  const onBlur = () => {
    updateMyData(index, id, value);
  }; */

 // Si el initialValue se cambia de forma externa, sincronizarlo con nuestro estado
 useEffect(() => {
  setValue(initialValue);
 }, [initialValue]);

 if (index === currentIndex && data[id] === values[id])
  return (
   <Placeholder animation="glow">
    <Placeholder xs={9} />
   </Placeholder>
  );
 //else if (index === currentIndex) return value;

 return value ? value : <></>;

 /*  return (
    <InputGroup>
      <Form.Control
        size="sm"
        type="text"
        className="p-1"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required
        //isInvalid
      />
    </InputGroup>
  ); */
};

// Establecer nuestro procesador de celdas editable como el procesador de celdas predeterminado
const defaultColumn = {
 Cell: EditableCell
};

const AdvanceTableWrapper = ({
 children,
 columns,
 data,
 sortable,
 selection,
 selectionColumnWidth,
 pagination,
 perPage = 10,
 updateMyData,
 skipPageReset,
 getRowProps = () => ({}),
 editableRowIndex,
 setEditableRowIndex,
 resetData
}) => {
 const {
  getTableProps,
  headers,
  page,
  prepareRow,
  canPreviousPage,
  canNextPage,
  nextPage,
  previousPage,
  setPageSize,
  gotoPage,
  pageCount,
  state: { pageIndex, pageSize, selectedRowIds, globalFilter, groupBy, expanded },
  setGlobalFilter,
  getTableBodyProps,
  headerGroups,
  rows,
  allColumns,
  getToggleHideAllColumnsProps
 } = useTable(
  {
   columns,
   data,
   disableSortBy: !sortable,
   initialState: { pageSize: pagination ? perPage : data.length },
   defaultColumn,
   // use la opción skipPageReset para deshabilitar el restablecimiento de la página temporalmente
   autoResetPage: !skipPageReset,
   // updateMyData no es parte de la API, pero
   // cualquier cosa que pongamos en estas opciones
   // estará disponible automáticamente en la instancia.
   // De esa manera podemos llamar a esta función desde nuestro
   // procesador de celdas!
   updateMyData,
   // pass state variables so that we can access them in edit hook later
   editableRowIndex,
   setEditableRowIndex // setState hook for toggling edit on/off switch
  },
  useGlobalFilter,
  useGroupBy,
  useSortBy,
  useExpanded,
  usePagination,
  useRowSelect,
  hooks => {
   if (selection) {
    hooks.visibleColumns.push(columns => [
     {
      id: 'selection',
      Header: ({ getToggleAllRowsSelectedProps }) => (
       <div className="">
        <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
       </div>
      ),
      headerProps: {
       className: 'p-1',
       style: {
        maxWidth: selectionColumnWidth
       }
      },
      cellProps: {
       style: {
        maxWidth: selectionColumnWidth
       }
      },
      Cell: ({ row }) => (
       <div>
        <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
       </div>
      )
     },
     ...columns
    ]);
   }
  }
 );

 const recursiveMap = children => {
  return React.Children.map(children, child => {
   if (child.props?.children) return React.cloneElement(child, { children: recursiveMap(child.props.children) });
   else {
    if (child.props?.table) {
     return React.cloneElement(child, {
      ...child.props,
      getTableProps,
      headers,
      page,
      prepareRow,
      canPreviousPage,
      canNextPage,
      nextPage,
      previousPage,
      gotoPage,
      pageCount,
      pageIndex,
      selectedRowIds,
      pageSize,
      setPageSize,
      globalFilter,
      setGlobalFilter,
      groupBy,
      expanded,
      getTableBodyProps,
      headerGroups,
      rows,
      allColumns,
      getToggleHideAllColumnsProps,
      getRowProps,
      resetData,
      updateMyData
     });
    } else {
     return child;
    }
   }
  });
 };

 return <>{recursiveMap(children)}</>;
};

export default AdvanceTableWrapper;
